<template>
  <game-template :success="isValid">
    <template v-if="isValid" v-slot:head>
      <p class="title">
        Vous avez complété ce module !
      </p>
      <button class="button" @click="exit">Enregistrer et quitter</button>
    </template>
    <template v-else v-slot:head>
      <p class="title">Complétez les phrases suivantes</p>
      <p class="sub-title">Vous trouverez l'information sur l'interface GTA.</p>
    </template>
    <template v-slot:content>
      <gap-fill-game-template :show-next-button="false" v-on:validate="validate" :button-enabled="canValidate" :show-error="hasValidate && touched.length === 0" :is-valid="isValid">
        <template v-slot:head>
          <zoomable-image>
            <img src="../assets/gap-fill-game/gap-fill-2.png">
          </zoomable-image>
        </template>
        <template v-slot:content>
          <p>
            <span>Nous sommes au dernier trimestre 2020, je dois solder les compteurs de</span>
            <gap-filler v-model="gaps.gap1.fill" :gap="gaps.gap1" :show-answers="hasValidate && !isTouched('gap1')" @touched="toggleTouched('gap1')"></gap-filler>
            <span>en priorité.</span>
            </p>
          <p>
            <span>Il reste</span>
            <gap-filler v-model="gaps.gap2.fill" :gap="gaps.gap2" :show-answers="hasValidate && !isTouched('gap2')" @touched="toggleTouched('gap2')"></gap-filler>
            <span>
              payables au collaborateur avant d’atteindre la limite. Si je fais un paiement de toutes les heures supplémentaires stockées, je
            </span>
            <gap-filler v-model="gaps.gap3.fill" :gap="gaps.gap3" :show-answers="hasValidate && !isTouched('gap3')" @touched="toggleTouched('gap3')"></gap-filler>
            <span>la limite puisqu’il y a</span>
            <gap-filler v-model="gaps.gap4.fill" :gap="gaps.gap4" :show-answers="hasValidate && !isTouched('gap4')" @touched="toggleTouched('gap4')"></gap-filler>
            <span>qui impacteraient le contingent d’heures supplémentaires.</span>
          </p>
        </template>
      </gap-fill-game-template>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'
import GapFillGameTemplate from '@shared/components/GapFillGameTemplate'
import GapFiller from '@shared/components/GapFiller'
import gapFillMixin from '@shared/mixins/gapFillMixin'

export default {
  name: 'GapFill2',
  mixins: [stepMixin, gapFillMixin],
  components: {
    GapFillGameTemplate,
    GapFiller
  },
  data () {
    return {
      gaps: {
        gap1: {
          fill: '',
          choices: ['RTT et d\'heures excédentaires', 'Congés payés et RTT', 'Congés payés et d\'heures excédentaires'],
          goodChoice: 'RTT et d\'heures excédentaires'
        },
        gap2: {
          fill: '',
          choices: ['217 heures supplémentaires', '35,08 heures supplémentaires', '220 heures supplémentaires'],
          goodChoice: '217 heures supplémentaires'
        },
        gap3: {
          fill: '',
          choices: ['ne dépasserai pas', 'je dépasserai'],
          goodChoice: 'ne dépasserai pas'
        },
        gap4: {
          fill: '',
          choices: ['45,08h', '65,08h', '10h'],
          goodChoice: '45,08h'
        }
      }
    }
  },
  methods: {
    validate () {
      this.touched = []
      this.hasValidate = true
      if (this.isValid) {
        this.$store.commit('setGapFillFinished', true)
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
